import {sleep} from './sleep.js';

export default class AudioFileToMediaStreamTrack {

  constructor (ctx, audioFile){
    // ctx // external audioContext passed from App.js
    this._ctx = new AudioContext(); 
     // ctx is locally defined for pause(), resume();
    this._audioFile = audioFile;
    this._init = this._init.bind(this);
    this._audioBuffer = undefined;
    this._source = undefined;
    this._destination = undefined;
    this._outputStreamTrack = undefined;

    this._loadAndDecode = this._loadAndDecode.bind(this);
    // console.log('AudioFileToMediaStreamTrack', 'constructor()');
    this.getOutputTrack = this.getOutputTrack.bind(this);

    this._init();
  }

  async play(){

    while (this._destination === undefined) await sleep(100);

    console.log('audio file play');
    this._source = this._ctx.createBufferSource(); 
    this._source.buffer = this._audioBuffer;
    this._source.connect(this._destination);

    this._source.start();


    this._source.onended = (e) => {
      console.log('audio source ended');
    };

    // console.log('outputStreamTrack', this._outputStreamTrack);
  }

  pause(){this._ctx.pause();}
  resume(){this._ctx.resume();}

  stop(){
    // console.log('audio file stop');
    this._source.stop();
  }
 
  async getOutputTrack(){
    while(this._outputStreamTrack === undefined) await sleep(100);

    return {track: this._outputStreamTrack, 
            sampleRate: this._audioBuffer.sampleRate};
  }

  async _init(){
    this._ctx.resume();
    this._audioBuffer = await this._loadAndDecode(this._audioFile);
    this._destination = this._ctx.createMediaStreamDestination();
    this._outputStreamTrack = this._destination.stream.getTracks()[0];
    console.log('init completed, sampleRate', this._audioBuffer.sampleRate);
  }


  async _loadAndDecode(file){

     let reader = new FileReader();
     let retval = undefined;

     reader.onload = async (e) => {
       try {
         this._ctx.decodeAudioData(reader.result,
            (audioBuffer) => retval = audioBuffer,
            (err) => console.log(err));
       } catch (err) {console.log(err)};
     }

     // console.log(file);
     reader.readAsArrayBuffer(file);

     while (retval === undefined) await sleep(100);

     // console.log('_loadAndDecode() retval', retval);
    
     return retval;
  }

}
